export const NAVTOGGLE = 'NAVTOGGLE';


export const navtoggle = (value) => {
    return {        
      type: 'NAVTOGGLE',
      payload: value,
    };
};